import { render } from "./Form.vue?vue&type=template&id=3eadf82f"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"
script.render = render

export default script